/**
@flow strict-local
@format
*/

export default {
  fontWeight: 'normal',
  extraLarge: { fontSize: 26, lineHeight: 34 },
  large: { fontSize: 20, lineHeight: 28 },
  medium: { fontSize: 16, lineHeight: 22 },
  small: { fontSize: 14, lineHeight: 20 },
  extraSmall: { fontSize: 12, lineHeight: 16 },
};
